var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay1Sm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1761px",
    height: "1227px",
    viewBox: "0 0 1761 1227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "84.9043554%",
    y1: "27.8853162%",
    x2: "50%",
    y2: "52.06221%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DCAD3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91ACF3",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)",
    points: "1171.04103 3.49613711e-14 1760.81071 8.35375505e-14 589.769678 1226.9075 -1.29240779e-13 1226.9075"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay1Sm);
export default __webpack_public_path__ + "static/media/overlay1-sm.6b00942d2ec0004cdc84c8eff17d09ab.svg";
export { ForwardRef as ReactComponent };